import { mpfRListsHttp } from '../../api/mpf-r-lists-http'
import { isArchivedFilter } from '../data'

interface PIIScanItemGrouped {
  DocName: string
  DocUrl: string
  EKey?: string
  ETag?: string
  ExtraData: boolean
  FieldCode: string
  FieldEntityPropertyName: string
  FieldTitle: string
  FindingString: string
  FoundText: string
  GroupedItemUUID: string
  IsDoc: boolean
  IsListItem: boolean
  ListCode: string
  ListItemCode: number
  ListItemCodeUrl: string
  ListItemGUID: string
  ListTitle: string
  PostRenderText: string
  PreRenderText: string
  ResultArray: any
  ScanCode: number
  TotalOccurancesCount: number
}
interface PIIScanItemGroupedMetadataArgs {
  isArchivedFilter: false | null | true
  isAscending?: boolean
  orderBy?: string
}

const LIST_NAME = 'PIIScanItemGroupedList'
const COLUMN_NAMES = {
  DocName: 'DocName',
  DocUrl: 'DocUrl',
  EKey: 'eKey',
  ETag: 'eTag',
  ExtraData: 'ExtraData',
  FieldCode: 'FieldCode',
  FieldEntityPropertyName: 'FieldEntityPropertyName',
  FieldTitle: 'FieldTitle',
  FindingString: 'FindingString',
  FoundText: 'FoundText',
  GroupedItemUUID: 'GroupedItemUUID',
  IsDoc: 'IsDoc',
  IsListItem: 'IsListItem',
  ListCode: 'ListCode',
  ListItemCode: 'ListItemCode',
  ListItemCodeUrl: 'ListItemCodeUrl',
  ListItemGUID: 'ListItemGUID',
  ListTitle: 'ListTitle',
  PostRenderText: 'PostRenderText',
  PreRenderText: 'PreRenderText',
  ResultArray: 'ResultArray',
  ScanCode: 'ScanCode',
  TotalOccurancesCount: 'TotalOccurancesCount',
}
const getPIIScanItemGroupedListMetadata = async (
  args: PIIScanItemGroupedMetadataArgs
): Promise<PIIScanItemGrouped[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = isArchivedFilter(args.isArchivedFilter)
  const ascending = args?.isAscending ?? true
  const orderBy = args?.orderBy ?? COLUMN_NAMES.ListTitle

  const items = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.DocName,
      COLUMN_NAMES.DocUrl,
      COLUMN_NAMES.ExtraData,
      COLUMN_NAMES.FieldCode,
      COLUMN_NAMES.FieldEntityPropertyName,
      COLUMN_NAMES.FieldTitle,
      COLUMN_NAMES.FindingString,
      COLUMN_NAMES.FoundText,
      COLUMN_NAMES.GroupedItemUUID,
      COLUMN_NAMES.IsDoc,
      COLUMN_NAMES.IsListItem,
      COLUMN_NAMES.ListCode,
      COLUMN_NAMES.ListItemCode,
      COLUMN_NAMES.ListItemCodeUrl,
      COLUMN_NAMES.ListItemGUID,
      COLUMN_NAMES.ListTitle,
      COLUMN_NAMES.PostRenderText,
      COLUMN_NAMES.PreRenderText,
      COLUMN_NAMES.ResultArray,
      COLUMN_NAMES.ScanCode,
      COLUMN_NAMES.TotalOccurancesCount,
      COLUMN_NAMES.EKey,
      COLUMN_NAMES.ETag
    )
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
    .get()

  return [...items] as PIIScanItemGrouped[]
}
export {
  COLUMN_NAMES,
  LIST_NAME,
  type PIIScanItemGrouped,
  type PIIScanItemGroupedMetadataArgs,
  getPIIScanItemGroupedListMetadata,
}
